import { gql } from 'apollo-boost';

export const CREATE_CHAT_ACTION = gql`
    mutation CreateChatAction($data: CreateChatActionInput!) {
        createChatAction(data: $data) {
            id
            ownerUserId
            slashCommand
            label
            description
            scope
            visibility
            promptTemplate
            isActive
            isSystem
            createdAt
            updatedAt
        }
    }
`;
